import styled from 'styled-components';
import { vars, pxToRem, fontWeight, media } from '$util/theme';
import Section from '$components/layout/Section';

export default styled(Section)`
  position: relative;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  height: 210px;

  ${media.up('md')} {
    height: 450px;
  }
  ${media.up('lg')} {
    height: 640px;
  }
  ${media.up('xl')} {
    min-height: 640px;
  }

  .Image > div {
    z-index: -1;
  }

  h1 {
    font-size: ${pxToRem(33)};
    font-weight: ${fontWeight.semiBold};
    color: ${vars.quantumverse.reskinColors.white};
    line-height: ${pxToRem(40)};
    ${media.up('md')} {
      text-align: center;
      font-size: ${pxToRem(68)};
      line-height: ${pxToRem(72)};
      text-align: left;
      width: 60%;
    }
    ${media.up('lg')} {
      width: 50%;
    }
  }
  .btn-primary {
    width: 178px;
    ${media.up('md')} {
      width: 224px;
    }
    a {
      margin: 0 auto;
      font-size: ${pxToRem(16)};
      font-weight: ${fontWeight.semiBold};
    }
  }
`;
